import { mapGetters, mapMutations } from 'vuex';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

export default {
    name: 'searchSort',
    inject: ['$eventBus'],
    props: {
        disableReset: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        mvtDropdownList,
    },
    data() {
        return {
            filterRedesignEnabled: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['msp']),
        sortBy: {
            set(val) {
                this.updateFilterTrigger('sort');
                this.$eventBus.$emit('eventbus-updatefilter', { sort: val });
            },
            get() {
                return this.msp.filter.sort;
            },
        },
        sortByData() {
            const preLabel = this.filterRedesignEnabled ? 'Sort by: ' : '';
            const sortByData = [
                {
                    text: this.molang('search.sort.relevant'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.relevant')}</span>`,
                    value: null,
                    urlKey: 'recommend',
                },
                {
                    text: this.molang('search.sort.priceLow'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.priceLow')}</span>`,
                    value: 'sortby-price-asc',
                    urlKey: 'lowestPrice',
                },
                {
                    text: this.molang('search.sort.priceHigh'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.priceHigh')}</span>`,
                    value: 'sortby-price-desc',
                    urlKey: 'highestPrice',
                },
                {
                    text: 'Newest',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Newest</span>`,
                    value: 'sortby-dom-asc',
                    urlKey: 'newest',
                },
                {
                    text: 'Oldest',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Oldest</span>`,
                    value: 'sortby-dom-desc',
                    urlKey: 'oldest',
                },
                {
                    text: this.molang('search.sort.updatedTimeDesc'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.updatedTimeDesc')}</span>`,
                    value: 'sortby-updated-desc',
                    urlKey: 'updatedDesc',
                },
                {
                    text: 'Best Value',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Best Value</span>`,
                    value: 'sortby-pricepersqft-asc',
                    urlKey: 'pricepersqftLeast',
                },
                {
                    text: 'Investment',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Investment</span>`,
                    value: 'sortby-investment-asc',
                    urlKey: 'investment',
                },
                {
                    text: this.molang('search.sort.lotBig'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.lotBig')}</span>`,
                    value: 'sortby-lot-desc',
                    urlKey: 'lotMost',
                },
                {
                    text: this.molang('search.sort.lotSmall'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.lotSmall')}</span>`,
                    value: 'sortby-lot-asc',
                    urlKey: 'lotLeast',
                },
                {
                    text: this.molang('search.sort.sqftBig'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.sqftBig')}</span>`,
                    value: 'sortby-sqft-desc',
                    urlKey: 'sqftMost',
                },
                {
                    text: this.molang('search.sort.sqftSmall'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.sqftSmall')}</span>`,
                    value: 'sortby-sqft-asc',
                    urlKey: 'sqftLeast',
                },
                {
                    text: 'Beds',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Beds</span>`,
                    value: 'sortby-beds-desc',
                    urlKey: 'bedrooms',
                },
                {
                    text: 'Baths',
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}Baths</span>`,
                    value: 'sortby-baths-desc',
                    urlKey: 'bathrooms',
                },
                {
                    text: this.molang('search.sort.distanceasc'),
                    labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${this.molang('search.sort.distanceasc')}</span>`,
                    value: 'sortby-distance-asc',
                    urlKey: 'closestAsc',
                },
            ];

            if (this.glb.rentals) {
                return sortByData.filter((item) => !item.value || item.value.indexOf('sortby-lot-') === -1);
            }
            return sortByData;
        },
        options() {
            return {
                defaultValue: this.disableReset ? undefined : null,
            };
        },
    },
    methods: {
        ...mapMutations('msp', ['updateFilterTrigger']),
        onOpened() {
            this.$emit('opened');
        },
        onClosed() {
            this.$emit('closed');
        },
    },
    created() {
        this.filterRedesignEnabled = this.getSplit('movoto-msp-filter-redesign-CW-2249');
    },
};
